import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'booleanTransform' })
export class BooleanTransformPipe implements PipeTransform {
  transform(value: boolean, trueToText?: string, falseToText?: string): string {
    return value == null ? '' : value == true ? (trueToText || 'Yes') :  (falseToText || 'No');
  };
}
